import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Scale } from "lucide-react";
import api from "@/lib/api";
import Reveal from "@/components/Reveal";

export default function LegalPage({ docKey, title, subtitle }) {
  const [text, setText] = useState("");

  useEffect(() => {
    api.get("/legal").then((r) => setText(r.data[docKey] || "")).catch(() => {});
  }, [docKey]);

  return (
    <div data-testid={`legal-page-${docKey}`} className="page-enter mx-auto max-w-4xl px-4 py-16 sm:px-8 lg:py-24">
      <Reveal>
        <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-orange-500">
          <Scale className="h-4 w-4" /> {subtitle}
        </p>
        <h1 className="mt-2 text-2xl font-extrabold uppercase tracking-tight sm:text-3xl lg:text-4xl">{title}</h1>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="card-tactical mt-10 p-6 sm:p-8">
          <p className="whitespace-pre-line text-sm leading-relaxed text-slate-300">{text || "Chargement..."}</p>
        </div>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="mt-8 text-xs text-slate-500">
          Une question sur ces conditions ? <Link to="/contact" className="font-bold text-orange-400 hover:text-orange-300">Contactez-nous</Link>.
        </p>
      </Reveal>
    </div>
  );
}
